// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { RotateCcw } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

export function AnswerError({
  message,
  onRetry,
  canRetry,
}: {
  message: string;
  onRetry: () => void;
  canRetry: boolean;
}) {
  const { t } = useTranslation();
  return (
    <div className="mb-2">
      <div role="alert" className="rounded-lg border border-destructive/30 bg-destructive/5 px-3 py-2 text-sm">
        <p className="font-medium text-destructive">{t("assistant.error.title")}</p>
        <p className="text-muted-foreground">{message}</p>
      </div>
      {canRetry && (
        <Button variant="outline" size="sm" className="mt-2" onClick={onRetry}>
          <RotateCcw className="h-4 w-4" />
          {t("assistant.error.retry")}
        </Button>
      )}
    </div>
  );
}
